export default __webpack_public_path__ + "static/media/getFetch.d7d6010d.cjs";